const message = {
    btnLoadMore: "Load more",
    goBack: "Go back",

};
export default message;